import React, { useContext, useEffect, useState } from 'react';
import { 
  Col, 
  Container, 
  Row, 
  Form, 
} from 'react-bootstrap';
import toast from 'react-hot-toast';
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FaExclamationCircle } from 'react-icons/fa'; // Optional icon for no data
import Pagination from 'react-bootstrap/Pagination';
import { AgentContext } from '../../../context/AgentContext';
import { ThemeContext } from '../../../context/ThemeContext';
import RejectedRequestCard from './RejectedRequestCard';
import { AuthContext } from '../../../context/AuthContext';
import { SideBarRefreshContext } from '../../../context/SideBarRefreshContext';

const RejectedRequest = () => {
  const { apiGlobal } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const [rejectedAgent, setRejectedAgent] = useState([]);
  const [filteragent, setFilterAgent] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const { setRefresh, refresh } = useContext(AgentContext);
  const { currentTheme } = useContext(ThemeContext);

  // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Use filteragent for pagination, not agent
  const currentItems = filteragent.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages should be based on filteragent length, not agent
  const totalPages = Math.ceil(filteragent.length / itemsPerPage);


  const fetchData = async () => {
    try {
      const response = await fetch(`${apiGlobal}/agent_rejectedRequest.php`);
      const data = await response.json();
  
      // console.log('Data:', data);
  
      if (data.status && data.message === 'Success') {
        // console.log('Data fetched:', data.data);
        setRejectedAgent(data.data);
        setFilterAgent(data.data);
      } else {
        // console.log('No data fetched');
        setFilterAgent([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to load data');
    }
  };
  


  useEffect(() => {
    // console.log('Refreshing data...');
    fetchData();
  }, [refresh, sideBarRefresh?.adminAgentRejectedRefresh]);
  
  

  // if (rejectedAgent.length <= 0) {
  //   return (
  //     <div>
  //       <p style={{
  //     backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
  //     color: currentTheme === 'Dark' ? 'white' : 'black',
  //   }}
  //       >No Agent Found
  //       </p>
  //     </div>
  //   );
  // }
  
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredData = rejectedAgent.filter(agentdata => agentdata.name.toLowerCase().includes(query.toLowerCase())
        || agentdata.city.toLowerCase().includes(query.toLowerCase())
        || agentdata.state.toLowerCase().includes(query.toLowerCase())
        || agentdata.country.toLowerCase().includes(query.toLowerCase()));
      setFilterAgent(filteredData);
    } else {
      setFilterAgent(rejectedAgent);
    }
  };

  const refreshHandler = () => {
    setRefresh(prev => !prev);
    setSearchQuery('');
    toast.success('Refresh....');
  };

  // use Effect to add keyframes for the pulse animation
  useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);

  return (
    <Container>
      <Row>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div style={{
                  display: 'flex', width: '25%', marginBottom: '10px', marginTop: '10px', alignItems: 'center',
                }}
          >
            <Form.Control
              type="text"
              placeholder="Search by Name......"
              value={searchQuery}
              onChange={handleSearch}
              style={{
                      height: '30px',
                      marginTop: '5px',
                      borderColor: 'green',
                      flexGrow: 1,
                    }}
            />
      
            <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
              <Button
                variant="outline-secondary"
                title="Refresh"
                size="sm"
                style={{ marginLeft: '10px' }}
                onClick={refreshHandler}
              >
                <span className="lnr lnr-sync" />
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </Row>
      <Row>
        <Container>
          {filteragent.length > 0 ? (
            currentItems.map(agentdata => (
              <RejectedRequestCard
                key={agentdata.id}
                id={agentdata.id}
                name={agentdata.name}
                address1={agentdata.address1}
                address2={agentdata.address2}
                area={agentdata.area}
                city={agentdata.city}
                state={agentdata.state}
                country={agentdata.country}
                remark={agentdata.reject_reason}
                username={agentdata.user_name}
                useremail={agentdata.user_email}
                userphone={agentdata.user_phone}
                setRefresh={setRefresh}
              />
            ))
          ) : (
             // If search results are empty
            <div style={{
              textAlign: 'center',
  padding: '50px',
  backgroundColor: '#f8d7da',
  borderRadius: '8px',
  marginTop: '20px',
              color: '#721c24',
  fontSize: '16px',
            }}
            >
              <div
                style={{
fontSize: '48px',
marginBottom: '20px',
color: '#e63946',
animation: 'pulse 1.5s infinite ease-in-out',
display: 'inline-block',
}}
              >
                <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
              </div>
              <p>{searchQuery ? 'No results found for your search' : 'No Rejected requests available'}</p>
            </div>
          )}
        </Container>
      </Row>

      {/* Pagination Controls */}
    
      <div
        style={{
          // position: 'fixed', 
          bottom: '20px', 
          right: '20px', 
          zIndex: 999, 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
          marginTop: '4px',
        }}
      >
        {filteragent.length > 0 && (
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
          ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        )}
        
      </div>
    </Container>
  );
};

export default React.memo(RejectedRequest);
